<template>
  <div class="col-12 nopads">
    <div class="col-sm-12 nopads">
      <h4 class="form-header pl-3">
        {{ $t('menu.orders') }}
      </h4>
      <div class="row nopasd pb-3">
        <div class="col-12 col-lg-12 col-xl-4">
          <span class="span-title pl-3">{{ $t('contracts.order_filter') }} </span>
          <div class="d-flex align-items-start">
            <div class="flex-grow-1 min-width-0">
              <multiselect
                id="orderStatusSelector"
                v-model="updateOrderFilter"
                :multiple="true"
                :options="orderStatusValues"
                :custom-label="value => getStatusString(value)"
                :searchable="true"
                :close-on-select="false"
                :placeholder="$t('orders.select_status')"
                :select-label="$t('orders.select_state')"
                :selected-label="$t('common.selected')"
                :deselect-label="$t('common.remove_selection')"
              />
            </div>
            <font-awesome-icon
              icon="trash"
              style="color: #636364"
              class="pointer mt-2 mx-2"
              @click.stop="clearOrderStatusSelection"
            />
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-4">
          <span class="span-title pl-3">{{ $t('contracts.order_task_type_filter') }} </span>
          <div class="d-flex align-items-start">
            <div class="flex-grow-1 min-width-0">
              <multiselect
                id="taskTypeSelector"
                v-model="updateTaskTypeFilter"
                :multiple="true"
                :options="taskTypeValues"
                track-by="name"
                label="name"
                :searchable="true"
                :close-on-select="false"
                :placeholder="$t('orders.select_status')"
                :select-label="$t('orders.select_task_type')"
                :selected-label="$t('common.selected')"
                :deselect-label="$t('common.remove_selection')"
              >
                <template
                  #singleLabel="props"
                >
                  <span class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                  </span>
                </template>
                <template
                  #option="props"
                >
                  <div class="option__desc">
                    <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                  </div>
                </template>
                <template #noResult>
                  <span>{{ $t('common.not_found') }}</span>
                </template>
                <template #noOptions>
                  <span>{{ $t('common.no_results') }}</span>
                </template>
              </multiselect>
            </div>
            <font-awesome-icon
              icon="trash"
              style="color: #636364"
              class="pointer mt-2 mx-2"
              @click.stop="clearOrderTaskTypeSelection"
            />
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-4">
          <span class="span-title pl-3">{{ $t('contracts.order_executor_filter') }} </span>
          <div class="d-flex align-items-start">
            <div class="flex-grow-1 min-width-0">
              <multiselect
                id="executorSelector"
                v-model="updateExecutorFilter"
                :multiple="true"
                :options="executorValues"
                track-by="name"
                label="name"
                :searchable="true"
                :close-on-select="false"
                :placeholder="$t('orders.select_executor')"
                :select-label="$t('orders.select_executor')"
                :selected-label="$t('common.selected')"
                :deselect-label="$t('common.remove_selection')"
              >
                <template #singleLabel="props">
                  <span class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                  </span>
                </template>
                <template #option="props">
                  <div class="option__desc">
                    <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                  </div>
                </template>
                <template #noResult>
                  <span>{{ $t('common.not_found') }}</span>
                </template>
                <template #noOptions>
                  <span>{{ $t('common.no_results') }}</span>
                </template>
              </multiselect>
            </div>
            <font-awesome-icon
              icon="trash"
              style="color: #636364"
              class="pointer mt-2 mx-2"
              @click.stop="clearExecutorSelection"
            />
          </div>
        </div>
      </div>
      <div
        v-if="contract.is_contract_party"
        class="d-flex justify-content-end pb-3 pe-2"
      >
              <div class="btn-group pt-1" role="group" aria-label="Basic example">
                  <div v-if="selectedOrders.length > 0" class="dropdown">
                      <button
                          class="btn btn-secondary btn-sm dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="true"
                          :disabled="selectedOrders.length < 1"
                      >
                          {{$t('common.actions')}} ({{selectedOrders.length}})
                      </button>

                      <ul class="dropdown-menu">
                          <li>
                              <button class="dropdown-item" @click="addOrderGeometry">
                                  {{ $t('orders.add_geometry_to_selected_orders') }}
                              </button>
                          </li>
                          <li>
                              <button class="dropdown-item" @click="openBulkExecutorEditor">
                                  {{ $t('orders.bulk_edit_executors') }}
                              </button>
                          </li>
                          <li>
                              <button class="dropdown-item" @click="showCloseOrdersModal">
                                  {{ $t('contracts.close_orders') }}
                              </button>
                          </li>
                          <li>
                              <button class="dropdown-item" @click="openBulkStatusEditor">
                                  {{ $t('orders.bulk_change_status') }}
                              </button>
                          </li>
                      </ul>
                  </div>
                  <button
                      v-else
                      class="btn btn-secondary btn-sm dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="true"
                      :disabled="true"
                  >
                      {{$t('common.actions')}} ({{selectedOrders.length}})
                  </button>

                  <button
                      v-if="!isContractClosed()"
                      class="btn btn-sm btn-primary"
                      :disabled="loading || contract.task_types.length === 0"
                      @click.stop="addOpenOrders"
                  >
                      <span>{{ $t('contracts.add_open_orders') }}</span>
                  </button>
                  <button
                      v-if="!isContractClosed()"
                      class="btn btn-sm btn-success"
                      :disabled="loading || contract.task_types.length === 0"
                      @click.stop="addOrder"
                  >
                      <span>{{ $t('contracts.add_order') }}</span>
                  </button>

              </div>

      </div>
      <div
        v-if="!loading && contract.task_types.length === 0 && contract.is_contract_party"
        class="no-task-types-text col-sm-7 col-md-6 col-lg-4 col-7 right"
      >
        <font-awesome-icon icon="exclamation-triangle" />
        <span class="p-2 text-danger">{{ $t('contracts.warning_task_types' ) }}</span>
      </div>
      <div class="col-sm-12">
        <order-list
          ref="orderList"
          :results="orders"
          :user="user"
          @edit="editOrder"
          @row-select="handleRowSelect"
        />
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <!-- Geometry -->
    <base-modal v-if="showGeometryForm" size="xl" hide-header hide-footer prevent-close no-padding>
        <order-geometry @geometry-selected="setOrderGeometries" @close="hideOrderGeometry"/>
    </base-modal>

    <base-modal v-if="showBulkExecutorEditor" size="lg" hide-header hide-footer>
        <bulk-executor-editor
          :selected-order-ids="selectedOrders.map(order => order.id)"
          :selected-orders="selectedOrders"
          :executor-options="contractorOptions"
          @update-executors="updateBulkExecutors"
          @close="closeBulkExecutorEditor"
        />
    </base-modal>

    <base-modal
        v-if="closeOrdersModal"
        size="lg"
        :hide-header="true"
        :hide-footer="true"
    >
        <bulk-order-closer
            :tiera-api-key-allowed="tieraApiKeyAllowed"
            :selected-orders="filteredSelectedOrders"
            @close="closeOrdersModal = false"
            @closeAndUpdate="ordersClosed"
        />
    </base-modal>

    <base-modal v-if="showBulkStatusEditor" size="lg" hide-header hide-footer allow-overflow>
        <bulk-status-editor
            @save="updateBulkStatus"
            @close="closeBulkStatusEditor"
        />
    </base-modal>

    <base-modal
        v-if="addOrdersModal"
        :hide-header="true"
        :hide-footer="true"
        @close="cancelOpening"
    >
      <div class="col-sm-12 pb-1">
        <span class="pb-2 title">{{ addMessage }}</span>
        <span>{{ $t('contracts.new_add_confirm_info') }}</span>
      </div>
      <div class="col-12 button-container">
        <button
          class="form-button btn btn-sm btn-secondary"
          @click="cancelOpening"
        >
          {{ $t('common.no') }}
        </button>
        <button
          class="form-button btn btn-sm btn-success"
          @click="doAddOpenOrders"
        >
          {{ $t('common.yes') }}
        </button>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {orderStatus, workManagementHelper} from '../mixins/WorkManagementMixin'
import {orderMixin} from "@/components/mixins/OrderMixin";
import OrderList from '../order/OrderList'
import OrderGeometry from '../order/OrderGeometry'
import {inject} from "vue";
import BulkExecutorEditor from '../order/BulkExecutorEditor'
import BaseModal from "@/components/BaseModal";
import OrderStatusBadge from "@/components/contractcalendar/OrderStatusBadge.vue";
import Multiselect from 'vue-multiselect';
import BulkOrderCloser from "../order/BulkOrderCloser.vue";
import BulkStatusEditor from '../order/BulkStatusEditor.vue';

export default {
    name: 'ContractOrders',
    components: {BulkOrderCloser, BulkStatusEditor, BaseModal, OrderList, OrderGeometry, OrderStatusBadge, Multiselect, BulkExecutorEditor},
    mixins: [workManagementHelper, restApi, orderMixin],
    props: {
        contract: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        },
        orderFilter: {
            type: Array,
            default() {
                return []
            }
        },
        tieraApiKeyAllowed: {
            type: Boolean,
            default: false
        },
        taskTypeFilter: {
            type: Array,
            default() {
                return []
            }
        },
        executorFilter: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            loading: true,
            orders: [],
            ordersToAdd: [],
            showGeometryForm: false,
            showBulkExecutorEditor: false,
            closeOrdersModal: false,
            addOrdersModal: false,
            allOrders: [],
            order: null,
            closeOnCancel: false,
            contractUpdate: JSON.parse(JSON.stringify(this.contract)),
            addMessage: '',
            updateOrderFilter: [],
            updateTaskTypeFilter: [],
            updateExecutorFilter: [],
            taskTypeValues: [],
            executorValues: [],
            contractorOptions: [],
            selectedOrders: [],
            showBulkStatusEditor: false
        }
    },
    computed: {
        orderStatusValues() {
            return Object.values(orderStatus)
        },
        filteredSelectedOrders() {
            return this.getSelectedOrdersForClosing()
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    watch: {
        contract(val) {
            if (this.contract.id > 0) {
                this.contractUpdate = val
                this.fetchContractOrders()
            }
        },
        updateOrderFilter() {
            this.$emit('setOrderFilter', this.updateOrderFilter)
            this.filterVisibleOrders()
        },
        updateTaskTypeFilter() {
            this.$emit('setTaskTypeFilter', this.updateTaskTypeFilter)
            this.filterVisibleOrders()
        },
        updateExecutorFilter() {
            this.$emit('setExecutorFilter', this.updateExecutorFilter)
            this.filterVisibleOrders()
        }
    },
    created: function () {
        if (this.contract.id > 0) {
            this.fetchContractOrders()
        }
        this.restFetch(this.contractorUrl, (response) => {
            if (response && response.data) {
                this.contractorOptions = response.data.map(c => ({ id: c.id, name: c.name }))
            }
        })
        this.updateOrderFilter = this.orderFilter
        this.updateTaskTypeFilter = this.taskTypeFilter
        this.updateExecutorFilter = this.executorFilter
    },
    methods: {
        fetchContractOrders: function () {
            this.orders = []
            this.loading = true
            this.restFetchParams(this.orderUrl, {contract: this.contractUpdate.id}, this.handleOrders)
        },
        handleOrders: function (response) {
            this.loading = false
            if (response != null) {
                this.allOrders = response.data
                this.getOrderTaskTypes()
                this.getOrderExecutors()
                this.filterVisibleOrders()
                this.$emit('ordersUpdated')
            }
        },
        getOrderTaskTypes() {
            this.taskTypeValues = this.allOrders
                .filter((item, index, self) => {
                    return index === self.findIndex((t) => t.contract_task_type.task_type.id === item.contract_task_type.task_type.id);
                })
                .map((item) => item.contract_task_type.task_type);
        },
        getOrderExecutors() {
            const executorMap = new Map();
            this.allOrders.forEach(order => {
                if (order.executors && order.executors.length > 0) {
                    order.executors.forEach(executor => {
                        if (executor.company && executor.company.id && executor.company.name) {
                            executorMap.set(executor.company.id, {
                                id: executor.company.id,
                                name: executor.company.name
                            });
                        }
                    });
                }
            });
            this.executorValues = Array.from(executorMap.values());
        },
        clearOrderStatusSelection() {
            this.updateOrderFilter = [];
        },
        clearOrderTaskTypeSelection() {
            this.updateTaskTypeFilter = [];
        },
        clearExecutorSelection() {
            this.updateExecutorFilter = [];
        },
        addOrderGeometry: function () {
            this.showGeometryForm = true
        },
        hideOrderGeometry: function () {
            this.showGeometryForm = false
        },
        openBulkExecutorEditor: function () {
            this.showBulkExecutorEditor = true
        },
        closeBulkExecutorEditor: function () {
            this.showBulkExecutorEditor = false
        },
        updateBulkExecutors: function (data) {
            this.loading = true
            this.restUpdate(this.orderExecutorsUrl, data, this.handleBulkExecutorUpdate, this.handleBulkExecutorUpdateFail)
        },
        handleBulkExecutorUpdate: function () {
            this.loading = false
            this.showBulkExecutorEditor = false
            this.fetchContractOrders()
            this.showAlert(this.$t('orders.executors_updated_successfully'), 'success')
            this.clearOrderSelection()
        },
        handleBulkExecutorUpdateFail: function () {
            this.loading = false
            this.showAlert(this.$t('orders.executors_update_failed'))
        },
        setOrderGeometries(geometries) {
            let orderIds = []
            const ordersToUpdate = this.selectedOrders.length > 0 ? this.selectedOrders : this.orders
            ordersToUpdate.forEach(item => {
                orderIds.push(item.id)
            })
            if (geometries && geometries.length > 0) {
                geometries.forEach(item => {
                    item.geometry = typeof item.geometry === 'object' && item.geometry !== null ? JSON.stringify(item.geometry) : item.geometry
                })
                this.restUpdate(this.orderGeometriesUrl, {orders: orderIds, geometries: geometries}, this.handleSetOrderGeometries, this.handleSetOrderGeometriesFail)
            } else {
                this.showGeometryForm = false
            }
        },

        handleSetOrderGeometries() {
            this.loading = false
            this.showGeometryForm = false
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.clearOrderSelection()
        },

        handleSetOrderGeometriesFail() {
            this.loading = false
            this.showGeometryForm = false
            this.showAlert(this.$t('orders.add_geometry_failed'))
        },

        filterVisibleOrders() {
            if (this.updateOrderFilter.length < 1 &&
                this.updateTaskTypeFilter.length < 1 &&
                this.updateExecutorFilter.length < 1) {
                this.orders = this.allOrders;
            } else {
                this.orders = this.allOrders.filter(order => {
                    const isOrderStatusMatch = this.updateOrderFilter.length < 1 ||
                        this.updateOrderFilter.includes(order.status);

                    const isTaskTypeMatch = this.updateTaskTypeFilter.length < 1 ||
                        this.updateTaskTypeFilter.some(filter =>
                            filter.id === order.contract_task_type.task_type.id);

                    const isExecutorMatch = this.updateExecutorFilter.length < 1 ||
                        (order.executors && order.executors.length > 0 &&
                            order.executors.some(executor =>
                                executor.company &&
                                this.updateExecutorFilter.some(selectedExecutor =>
                                    selectedExecutor.id === executor.company.id)));

                    return isOrderStatusMatch && isTaskTypeMatch && isExecutorMatch;
                });
            }
        },
        editOrder: function (order) {
            this.$emit('editOrder', this.createEditorOrder(order))
        },
        close: function () {
            this.$emit('showList')
        },
        closeAndUpdate: function (data) {
            if (this.contract.id < 1 && data.id > 0) {
                // If we just added a contract successfully, ask to create orders as well
                this.contractUpdate = data
                this.addOpenOrders()
                this.closeOnCancel = true
            } else {
                this.$emit('closeAndUpdate')
            }
        },
        addOrder: function () {
            this.$emit('addOrder', this.createEditorOrder())
        },
        isContractClosed: function () {
            // Check if end date is before today
            if (this.contractUpdate.id > 0) {
                let today = new Date()
                today.setHours(23)
                today.setMinutes(59)
                today.setSeconds(59)
                let endDate = Date.parse(this.contract.end_date)
                return today.getTime() > endDate
            }
            return false
        },
        showCloseOrdersModal: function () {
            this.closeOrdersModal = true
        },
        addOpenOrders: function () {
            this.addMessage = this.$t('contracts.add_confirm')
            this.addOrdersModal = true
        },
        doAddOpenOrders: function () {
            this.addOrdersModal = false
            let contractTasks = this.contractUpdate.task_types
            this.ordersToAdd = []
            for (let i = 0; i < contractTasks.length; i++) {
                let item = contractTasks[i]
                let o = this.orders.find(order =>
                    order.contract_task_type.task_type.id === item.task_type.id &&
                    order.status < 10) // 10 = Completed - referring to mixin const not working
                if (o === undefined) {
                    let newOrder = this.createEditorOrder()
                    newOrder.executors.push({company: {id: this.contractUpdate.contractor.id}})
                    newOrder.contract = {id: this.contractUpdate.id}
                    newOrder.contract_task_type = {id: item.id}
                    newOrder.unit = item.unit
                    this.ordersToAdd.push(newOrder)
                }
            }
            // Submit orders one by one
            this.submitOrders()
        },
        submitOrders: function () {
            if (this.ordersToAdd && this.ordersToAdd.length > 0) {
                this.loading = true
                this.restAdd(this.orderUrl, this.ordersToAdd[0], this.handleSubmitSuccess, this.handleSubmitFail)
            } else {
                this.$emit('ordersUpdated')
            }
        },
        handleSubmitSuccess: function () {
            this.ordersToAdd.splice(0, 1)
            if (this.ordersToAdd.length > 0) {
                this.submitOrders()
            } else {
                this.fetchContractOrders()
                this.$emit('ordersUpdated')
            }
        },
        handleSubmitFail: function () {
            this.loading = false
            this.showAlert(this.$t('contracts.add_error'))
        },
        cancelOpening: function () {
            this.addOrdersModal = false
            if (this.closeOnCancel) {
                this.$emit('closeAndUpdate')
            }
        },
        ordersClosed: function () {
            this.fetchContractOrders()
            this.closeOrdersModal = false
        },
        handleRowSelect: function (selectedRows) {
            this.selectedOrders = selectedRows.map(selected =>
                this.allOrders.find(order => order.id === selected.id)
            ).filter(order => order !== undefined)
        },
        getSelectedOrdersForClosing: function () {
            return this.selectedOrders
        },
        clearOrderSelection: function () {
            this.selectedOrders = []
            if (this.$refs.orderList) {
                this.$refs.orderList.clearSelection()
            }
        },
        hasActiveOrders() {
            return this.orders.length > 0 &&
                this.orders.filter(item => item.status === orderStatus.OPEN || item.status === orderStatus.IN_PROGRESS).length > 0
        },
        openBulkStatusEditor: function () {
            this.showBulkStatusEditor = true
        },
        closeBulkStatusEditor: function () {
            this.showBulkStatusEditor = false
        },
        updateBulkStatus: function (status) {
            this.loading = true
            this.restUpdate(this.orderStatusUrl, {
                ids: this.selectedOrders.map(order => order.id),
                status: status
            }, this.handleBulkStatusUpdate, this.handleBulkStatusUpdateFail)
        },
        handleBulkStatusUpdate: function () {
            this.loading = false
            this.showBulkStatusEditor = false
            this.fetchContractOrders()
            this.showAlert(this.$t('orders.status_updated_successfully'), 'success')
            this.clearOrderSelection()
        },
        handleBulkStatusUpdateFail: function () {
            this.loading = false
            this.showAlert(this.$t('orders.status_update_failed'))
        }
    }

}
</script>

<style scoped>
.min-width-0 {
    min-width: 0;
}

.clear-selection-button {
    margin-top: 22px;
}

.clear-icon {
    margin-right: 5px;
    font-weight: bold;
    color: red;
}
</style>
